import NotificationState, {
    initialNotificationState,
} from 'notification/NotificationState';
import { NotificationActionType, NotificationAction } from './actions';
import { Reducer } from 'redux';
import { addItemToArrayWithMaxSize } from 'utils/arrays/arrayUtils';

const reducer: Reducer<NotificationState, NotificationAction> = (
    state = initialNotificationState,
    action
) => {
    switch (action.type) {
        case NotificationActionType.SHOW_NOTIFICATION:
            return {
                ...state,
                notifications: state.notifications.concat(action.payload!),
                archived: addItemToArrayWithMaxSize(
                    action.payload!,
                    state.archived,
                    100
                ),
            };
        case NotificationActionType.HIDE_NOTIFICATION:
            return {
                ...state,
                notifications: state.notifications.filter(
                    (n) => n.id !== action.payload!.id
                ),
            };
        case NotificationActionType.HIDE_ALL_NOTIFICATIONS:
            return {
                notifications: [],
                archived: state.archived,
            };
        default:
            return state;
    }
};

export default reducer;
